import React from "react";
import { Box } from "@mui/material";
import ArrowBackOutlined from "@mui/icons-material/ArrowBackOutlined";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "../../../shared/hooks/sharedHooks";
import { PublicState } from "../../publicSlice";
import { dt } from "../../../shared/themes/redesignTokens";
import useTranslation from "../../../shared/hooks/useTranslation";

const KioskBackButton: React.FC = () => {
  const { machine } = useAppSelector<PublicState>((state: any) => state.public);
  const navigate = useNavigate();
  const { translate } = useTranslation("public");

  const handleClick = () => {
    if (machine?.internalNumber) {
      navigate(`/public/machines/${machine.internalNumber}`);
    } else {
      navigate(-1);
    }
  };

  return (
    <Box
      onClick={handleClick}
      sx={{
        position: "fixed",
        bottom: "max(16px, env(safe-area-inset-bottom, 0px) + 8px)",
        left: "50%",
        transform: "translateX(-50%)",
        zIndex: 100,
        display: "flex",
        alignItems: "center",
        gap: "6px",
        padding: "8px 24px",
        borderRadius: "24px",
        backgroundColor: dt.cardBg,
        boxShadow: "0 2px 12px rgba(0,0,0,0.12), 0 1px 4px rgba(0,0,0,0.06)",
        cursor: "pointer",
        userSelect: "none",
        WebkitTapHighlightColor: "transparent",
        transition: "transform 150ms ease",
        "&:active": {
          transform: "translateX(-50%) scale(0.97)",
        },
      }}
    >
      <ArrowBackOutlined
        sx={{ fontSize: "18px", color: dt.textPrimary }}
      />
      <Box
        sx={{
          fontSize: "13px",
          fontWeight: 600,
          fontFamily: dt.font,
          color: dt.textPrimary,
          whiteSpace: "nowrap",
        }}
      >
        {translate("kioskBackToMenu")}
      </Box>
    </Box>
  );
};

export default KioskBackButton;
